export const OBJEKT_MONTAGE_STANDARD = {
    modus: "tage",
    montagetage: 1,
    montagestunden: 8,
    monteure: 2,
    nettoLohnProStundeCents: 4000,
    margeProzent: 60,
    anfahrtBruttoCents: 4500,
    anfahrten: 1,
    handlingBruttoProDekometerCents: 0,
    inGruppenpreisen: true,
};
export const STUNDEN_PRO_MONTAGETAG = 8;
export const OBJEKT_VERSAND_STANDARD = { pakete: 0, paketPreisNettoCents: 3400 };
//# sourceMappingURL=objekt.js.map